import {
  POST_TRIBUN_SEARCH_REQUEST,
  POST_TRIBUN_SEARCH_SUCCESS,
  POST_TRIBUN_SEARCH_FAILURE,
  RESET_SEARCH_AREA,
  RESET_SEARCH_MATCH,

  POST_TRIBUN_MENTION_SEARCH_REQUEST,
  POST_TRIBUN_MENTION_SEARCH_SUCCESS,
  POST_TRIBUN_MENTION_SEARCH_FAILURE,

  SEARCH_PREDICTIONS_REQUEST,
  SEARCH_PREDICTIONS_SUCCESS,
  SEARCH_PREDICTIONS_FAILURE,

  GET_SEARCHED_EVENT_COUPON_REQUEST,
  GET_SEARCHED_EVENT_COUPON_SUCCESS,
  GET_SEARCHED_EVENT_COUPON_FAILURE,

  FOLLOW_TRIBUN_USER_REQUEST,
  FOLLOW_TRIBUN_USER_SUCCESS,
  FOLLOW_TRIBUN_USER_FAILURE,

  LIKE_OR_UNLIKE_COUPON_REQUEST,
  LIKE_OR_UNLIKE_COUPON_SUCCESS,
  LIKE_OR_UNLIKE_COUPON_FAILURE,

  SEND_COMMENT_REQUEST,
  SEND_COMMENT_SUCCESS,
  SEND_COMMENT_FAILURE,

  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,

  COMMENT_FORBID_ALLOW_REQUEST,
  COMMENT_FORBID_ALLOW_SUCCESS,
  COMMENT_FORBID_ALLOW_FAILURE,

  SHOW_OR_HIDE_COUOPON_REQUEST,
  SHOW_OR_HIDE_COUOPON_SUCCESS,

  UPDATE_TRIBUN_COUPON_NAME_REQUEST,
  UPDATE_TRIBUN_COUPON_NAME_SUCCESS,
  UPDATE_TRIBUN_COUPON_NAME_FAILURE,

  DELETE_TRIBUN_COUPON_NAME_REQUEST,
  DELETE_TRIBUN_COUPON_NAME_SUCCESS,
  DELETE_TRIBUN_COUPON_NAME_FAILURE
} from 'Store/constants';

import {
  likeOrUnlikeStoreStateChanger,
  sendCommentStoreStateChanger,
  deleteCommentStoreStateChanger,
  updateTribunCouponNameStoreStateChanger,
  deleteTribunCouponNameStoreStateChanger,
  commentForbiddenStoreStateChanger,
  shareOrHideStoreStateChanger,
} from 'Utils/tribunStoreHelpers';

const initialState = {
  isLoading: false,
  error: null,
  users: [],
  mentionUsers: [],
  lastPage: false,
  follow: [],
  data: [],
  predictions: []
};

export default (state = initialState, action) => {
  switch (action.type) {

    case POST_TRIBUN_SEARCH_REQUEST:
      return { ...state, isLoading: true, error: null };
    case POST_TRIBUN_SEARCH_SUCCESS:
      return {
        ...state, users: action.payload.users.length ? [...state.users, ...action.payload.users] : [],
        lastPage: action.lastPage, isLoading: false, error: null
      };
    case POST_TRIBUN_SEARCH_FAILURE:
      return { ...state, isLoading: false, lastPage: action.lastPage, error: action.payload };

    case POST_TRIBUN_MENTION_SEARCH_REQUEST:
      return { ...state, isLoading: true, error: null };
    case POST_TRIBUN_MENTION_SEARCH_SUCCESS:
      return {
        ...state, mentionUsers: action.payload.users.length ? [...state.mentionUsers, ...action.payload.users] : [],
        lastPage: action.lastPage, isLoading: false, error: null
      };
    case POST_TRIBUN_MENTION_SEARCH_FAILURE:
      return { ...state, isLoading: false, lastPage: action.lastPage, error: action.payload };
    case RESET_SEARCH_AREA:
      return { ...initialState };

    case RESET_SEARCH_MATCH:
      return { ...state, predictions: [], isLoading: false, error: null };

    case SEARCH_PREDICTIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SEARCH_PREDICTIONS_SUCCESS:
      return {
        ...state, users: action.payload?.users?.length ? [...state.users, ...action.payload.users] : [],
        lastPage: action.lastPage, isLoading: false, error: null, predictions: action.payload
      };
    case SEARCH_PREDICTIONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_SEARCHED_EVENT_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_SEARCHED_EVENT_COUPON_SUCCESS:
      return { ...state, data: [...state.data, ...action.payload?.feeds], predictions: [],
        isLoading: false, lastPage: action.payload?.feeds?.length < action?.count,  error: null };
    case GET_SEARCHED_EVENT_COUPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case FOLLOW_TRIBUN_USER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FOLLOW_TRIBUN_USER_SUCCESS:
    {
      if (action.tabType === 'search') {
        state.data.map(item => {
          if (action.userId === item.user.userId) {
            item.user.following = !item.user.following;
            item.user.following ? ++item.user.stats.followers : --item.user.stats.followers;
          }
        });
      }
      return { ...state, isLoading: false, error: null };
    }
    case FOLLOW_TRIBUN_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case LIKE_OR_UNLIKE_COUPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LIKE_OR_UNLIKE_COUPON_SUCCESS:
    {
      if (action.tabType === 'search') {
        state = likeOrUnlikeStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case LIKE_OR_UNLIKE_COUPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case SEND_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SEND_COMMENT_SUCCESS:
    {
      if (action.tabType === 'search') {
        state = sendCommentStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case SEND_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case DELETE_COMMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case DELETE_COMMENT_SUCCESS:
    {
      if (action.tabType === 'search') {
        state = deleteCommentStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case DELETE_COMMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case COMMENT_FORBID_ALLOW_REQUEST:
      return { ...state, isLoading: true, error: null };
    case COMMENT_FORBID_ALLOW_SUCCESS:
    {
      if (action.tabType === 'search') {
        state = commentForbiddenStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case COMMENT_FORBID_ALLOW_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SHOW_OR_HIDE_COUOPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SHOW_OR_HIDE_COUOPON_SUCCESS:
    {
      if (action.tabType === 'search') {
        state = shareOrHideStoreStateChanger(state, action);
      }
      return { ...state, isLoading: false, error: null };
    }
    case UPDATE_TRIBUN_COUPON_NAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_TRIBUN_COUPON_NAME_SUCCESS:
    {
      state = updateTribunCouponNameStoreStateChanger(state, action);
      return { ...state, isLoading: false, error: null };
    }
    case UPDATE_TRIBUN_COUPON_NAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case DELETE_TRIBUN_COUPON_NAME_REQUEST:
      return { ...state, isLoading: true, error: null };
    case DELETE_TRIBUN_COUPON_NAME_SUCCESS:
      state = deleteTribunCouponNameStoreStateChanger(state, action);
      return { ...state, isLoading: false, error: null };
    case DELETE_TRIBUN_COUPON_NAME_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
